import { useEffect } from "react";
import useAnalytics, { EventType } from "./useAnalytics";

export default function useTrackOnLoad(event: EventType) {
  const analytics = useAnalytics();

  useEffect(() => {
    analytics.track(event);
  }, []);
}
